import { useGetUserMetricsQuery } from '@/affiliate-dashboard/graphql';
import { Loading } from '@/components/base/loading';
import { PageHeading } from '@/components/base/page-heading';
import { useTranslation } from 'react-i18next';
import { useIntl } from 'react-intl';
import invariant from 'tiny-invariant';

export function CampaignCoupons(): JSX.Element | null {
  const { t } = useTranslation();
  const intl = useIntl();
  const { data, loading } = useGetUserMetricsQuery();

  if (loading) {
    return <Loading />;
  }
  invariant(
    data?.userMetrics?.activeCampaignsCoupons,
    'Coupon codes are not available',
  );
  const coupons = data?.userMetrics?.activeCampaignsCoupons;

  if (coupons.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2 rounded-lg border border-green-300 bg-green-500 bg-opacity-10 p-4">
      <PageHeading subheading={t('campaignCoupons.subtitle')}>
        {t('campaignCoupons.title')}
      </PageHeading>

      <div className="flex flex-col gap-2">
        {coupons.map((coupon) => {
          const config: { amount?: number } = JSON.parse(
            coupon?.config ?? '',
          ) as { amount?: number };

          return (
            <div key={coupon?.code} className="flex items-center gap-2">
              <span className="text-default-gray-950 dark:text-white">
                {intl.formatNumber((config.amount ?? 0) / 100, {
                  style: 'percent',
                  maximumFractionDigits: 2,
                })}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
